module.exports = __webpack_public_path__ + "img/17.71f71d96.png";